module.exports = __webpack_public_path__ + "img/event-default.f0dffcf0.jpg";